import axios from 'axios';
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import styled from 'styled-components';

// 현재 프로젝트 명을 보여주는 컴포넌트
class ProjectTitle extends Component {
  constructor(props) {
    super(props);
    this.state = {
      projectTitle: '-',
      projectId: props.match.params.projectId,
      projectInfo: {},
      carbonReduction: 0,
    }
  }
  async componentDidMount() {
    await this.getProjectInfo();
    await this.getCarbonReduction();
  }

  async getProjectInfo() {
    const { projectId } = this.state;
    try {
      const res = await axios.get(`/cst/api/project/id/${projectId}`);

      if (res.status === 200) {
        const projectTitle = res.data.name;
        this.setState({ projectTitle, projectInfo: res.data });
      } else {
        this.setState({ projectTitle: "-" });
      }
    } catch (error) {
      console.error("Error fetching project info:", error);
      this.setState({ projectTitle: "-" });
    }
  }

  async getCarbonReduction() {
    const { projectId } = this.state;
    try {
      const res = await axios.get(`/cst/api/carbon-neutral/reduction/${projectId}`);
      if (res.status === 200) {
        let carbonReduction = res.data.carbonReduction;
        if (typeof carbonReduction === "number") {
          carbonReduction = carbonReduction.toFixed(4);
        } else {
          carbonReduction = 0;
        }
        this.setState({ carbonReduction });
      }
    } catch (error) {
      console.error("Error fetching carbon reduction:", error);
    }
  }

  render() {
    const { projectTitle, carbonReduction } = this.state;
    const reduction = autoConvertCarbonReduction(carbonReduction);
    const { t } = this.props;
    return (
      <TitleWrap>
        <div>
          <div>
            <img src="/images/ctors/icon/project-icon.png" alt="" />
            {projectTitle}
          </div>
          <span>
            {t('key77')} : {reduction.value || 0} {reduction.unit || 'tCO₂eq'}
          </span>
        </div>
      </TitleWrap>
    );
  }
}

const TitleWrap = styled.div`
  position: relative;
  width: 100%;
  height: 40px;
  color: var(--grey-900);
  background-color: var(--primary-500);
  box-sizing: border-box;
  font-size: 12px;
  line-height: 23px;
  font-weight: 600;

  & > div {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: absolute;
    top: 50%;
    left: 50%;
    height: 23px;
    transform: translate(-50%, -50%);
    width: 1200px;
  }
  & img {
    width: 22px;
    height: 22px;
    margin-right: 10px;
  }


`;

export default withTranslation()(ProjectTitle);


function convertFromTon(valueInTon, targetUnit = 'kg') {
  const value = Number(valueInTon);
  switch (targetUnit.toLowerCase()) {
    case 'kg':
      return value * 1000;
    case 'g':
      return value * 1_000_000;
    case 't':
    default:
      return value;
  }
}

function autoConvertCarbonReduction(valueInTon) {
  if (valueInTon === null || valueInTon === undefined) {
    return '0 tCO₂eq';
  }
  if (isNaN(valueInTon)) {
    return '0 tCO₂eq';
  }
  if (valueInTon === 0) {
    return '0 tCO₂eq';
  }
  const absTon = Math.abs(valueInTon);
  
  if (absTon < 0.001) {
    const grams = convertFromTon(valueInTon, 'g');
    return {
      value: grams.toFixed(1),
      unit: 'gCO₂eq',
      display: `${grams.toFixed(1)} gCO₂eq`
    }
  } else if (absTon < 1) {
    const kilograms = convertFromTon(valueInTon, 'kg');
    return {
      value: kilograms.toFixed(2),
      unit: 'kgCO₂eq',
      display: `${kilograms.toFixed(2)} kgCO₂eq`
    };
  } else {
    const tons = convertFromTon(valueInTon, 't');
    return {
      value: tons.toFixed(2),
      unit: 'tCO₂eq',
      display: `${tons.toFixed(2)} tCO₂eq`
    };
  }
}
